export default __webpack_public_path__ + "static/media/procurementValue2.ef63a767.png";